/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { createSlice } from '@reduxjs/toolkit'
import oidcApi from '@redux/apis/oidc'

export const REDUCER_NAME = 'oidc'

const oidcSlice = createSlice({
  name: REDUCER_NAME,
  initialState: {},
  reducers: {},
  extraReducers: builder => {
    // Assign a reducer path to oidcApi and record the request status for Redux DevTools
    builder
      .addMatcher(
        oidcApi.endpoints.getGCPDeploymentTerraformTemplate.matchPending,
        () => {}
      )
      .addMatcher(
        oidcApi.endpoints.getGCPDeploymentTerraformTemplate.matchFulfilled,
        () => {}
      )
      .addMatcher(oidcApi.endpoints.getGCPProject.matchPending, () => {})
      .addMatcher(oidcApi.endpoints.getGCPProject.matchFulfilled, () => {})
      .addMatcher(
        oidcApi.endpoints.postGCPCloudAccountOIDC.matchPending,
        () => {}
      )
      .addMatcher(
        oidcApi.endpoints.postGCPCloudAccountOIDC.matchFulfilled,
        () => {}
      )
  },
})

export default oidcSlice.reducer
